interface IProps {
  hastawktochat: boolean;
  tawktochat: string;
}

export const register = (props: IProps) => {
  if (!props.hastawktochat) {
    return;
  }

  const script = document.createElement('script');
  (window as any).intercomSettings = { app_id: props.tawktochat };
  script.type = 'text/javascript';
  script.async = true;
  script.charset = 'UTF-8';
  script.setAttribute('crossorigin', '*');
  script.src = `https://embed.tawk.to/${props.tawktochat}${props.tawktochat.includes('/') ? '' : '/default'}`;
  return script;
};

export const unregister = (props: IProps) => {
  if (!props.hastawktochat) {
    return;
  }

  (window as any).Tawk_API.hideWidget();
  delete (window as any).Tawk_API;
};
